import { render, staticRenderFns } from "./Migrations.vue?vue&type=template&id=acaa2f72&scoped=true"
import script from "./Migrations.vue?vue&type=script&lang=js"
export * from "./Migrations.vue?vue&type=script&lang=js"
import style0 from "./Migrations.vue?vue&type=style&index=0&id=acaa2f72&prod&scoped=true&lang=css"
import style1 from "./Migrations.vue?vue&type=style&index=1&id=acaa2f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa2f72",
  null
  
)

export default component.exports